export default __webpack_public_path__ + "static/media/Rectangle 105.e398590a.png";